import React, { useMemo, useState, useEffect } from 'react';
import { Tile } from '@dsi/react-eds';
import { useParams } from "react-router-dom";
import useGetDashboardListData from '../../hooks/useGetDashboardListData';

import useCustomerData from '../../Context/CustomerDataContext';
import DynamicChart from '../Charts/DynamicChart';
import DynamicLayout from '../LayOuts/DynamicLayout';
import '../LayOuts/DynamicDashboard.css';

const DashboardPreview = (props) => {
    const { customer } = useCustomerData();
    const { dashboard_id } = useParams();
    const { data: respDashboardData } = useGetDashboardListData(customer);
    const [dashboardData, setDashboardData] = useState([{}]);
    const [dashboardname, setDashboardName] = useState("");

    useEffect(() => {
      if (respDashboardData?.data) {
        const data = respDashboardData?.data.filter((d) => d.id == dashboard_id)
        setDashboardData(data); 
        setDashboardName(data[0]?.name);
      }
    }, [respDashboardData?.data, dashboard_id]); 
    
    const cards = dashboardData ? dashboardData[0]?.cards : [];

    const cardsWithComponents = cards?.map((card) => {
      return {
        ...card,
        component: (props) => <DynamicChart {...props} {...card.chartProps} source={'dashboard'} />
      };
    });

    return (
      <Tile title={dashboardname}>
        <DynamicLayout cards={cardsWithComponents} />
      </Tile>
  );
};

export default React.memo(DashboardPreview);
